import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import NavLink from 'react-router-dom/NavLink';
import { push } from 'react-router-redux/actions';
import { bindActionCreators } from 'redux';
import { Button, ButtonRounded } from '../components/actions';
import { logoutUser } from '../container/LoginPage/action';
import { SET_REPORTS_LIST_OPEN_ACTION } from '../container/ReportsPage/action';
import logo from '../img/logo.png';
import { getIsReportsListOpen, getUser, selectIsUserAuthorized } from '../selectors';
import s from './Header.css';

const mapStateToProps = (state, ownProps) => ({
    isUserLoggedIn: selectIsUserAuthorized(state),
    userData: getUser(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    logoutAction: bindActionCreators(logoutUser, dispatch),
});

class Header extends React.Component {
    render() {
        const { isUserLoggedIn, userData } = this.props;

        return (
            <header className={s.header}>
                <div className={s.wrapper}>
                    <div className={s.navigationSection}>{this.props.children}</div>

                    <div className={s.logoSection}>
                        <img src={logo} alt="" />
                    </div>

                    <div className={s.userSection}>
                        {this.props.isUserLoggedIn && this.props.userData && (
                            <Fragment>
                                <div className={s.sectionInner}>
                                    <ButtonRounded
                                        onClick={this.props.logoutAction}
                                        label={
                                            'Logout' + (this.props.userData.name ? ' ' + this.props.userData.name : '')
                                        }
                                        design="warning"
                                        align="right"
                                    />
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </header>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./app/web/src/layout/Header.jsx